import styled from "styled-components";
import { Dialog, InputGroup } from "@blueprintjs/core";

export const CopyInputGroup = styled(InputGroup)`
  height: 30px;
`;

export const CenterAlign = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const DialogBody = styled.div`
  padding: 20px;
  width: 800px;
`;

export const CleanDialog = styled(Dialog)`
  padding: 0;
  overflow: hidden;
`;

export const VisibilityWarning = styled.div`
  font-size: var(--global-font-size-xs);
  margin-left: 4px;
  margin-top: 8px;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  gap: 8px;
`;
